// extracted by mini-css-extract-plugin
module.exports = {"sponsored_text":"SponsorMessage_sponsored_text__qP8cr"};